





















import { Component, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import SellCoinsCampaignListItem from '@/componentsV2/templates/SellCoinsCampaignListItem/SellCoinsCampaignListItem.vue';
import ProgramStatusTag from '@/componentsV2/atoms/ProgramStatusTag/ProgramStatusTag.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import ArrowRightInfoIcon from '@/components/icons/ArrowRightInfo.vue';

@Component({
  components: {
    Typography,
    SellCoinsCampaignListItem,
    ProgramStatusTag,
    GhostButton,
    ArrowRightInfoIcon
  }
})
export default class SellCoinsItem extends Vue {
  @Prop() item!: any;

  goToSellCoinsDetail() {
    this.$router.push('/sell-coins');
  }
}
